import { Quote } from 'types/studio/studio';
import { Typography } from '@ag1/ui';
import styles from './EduArticlesQuote.module.scss';

export const EduArticlesQuote = ({ text }: Quote) => (
  <Typography variant="headline" size="2" noPadding className={styles.quote}>
    {text}
  </Typography>
);
